import { Injectable } from '@angular/core';
import { UtilService } from '@polaris-customerweb/sharedcomponents.core';
import { Image } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';
import { ImageResourceService } from './image-resource.service';

@Injectable({ providedIn: 'root' })
export class ImageService {
    constructor(
        private imageResourceService: ImageResourceService,
        private utilService: UtilService
    ) {}

    uploadImageBlob(blob: Blob, timestamp = new Date().toISOString()) {
        const formData = this.utilService.blobToFormPost(blob);
        return this.imageResourceService.uploadImage(formData, timestamp);
    }

    uploadImageDataUrl(dataUrl: string, timestamp?: string): Observable<Image> {
        const blob = this.utilService.dataURItoBlob(dataUrl);
        return this.uploadImageBlob(blob, timestamp);
    }

    uploadImageFile(file: File): Observable<Image> {
        const formData = this.utilService.fileToFormPost(file);
        const modifiedEpoch = file.lastModified;
        const modifiedDate =
            modifiedEpoch <= 0 ? new Date() : new Date(modifiedEpoch);

        // todo: get lat and lng from image file

        return this.imageResourceService.uploadImage(
            formData,
            modifiedDate.toISOString()
        );
    }

    getImage(id: string): Observable<Image> {
        return this.imageResourceService.getImage(id);
    }
}
